export default __webpack_public_path__ + "static/media/InactiveReorder.817c6457.svg";